import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

export default function ConfirmationDialog({
    open,
    title,
    message,
    confirmButtonText,
    confirmButtonColor,
    onClose,
    onConfirm,
}) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Cancelar
                </Button>
                <Button onClick={onConfirm} color={confirmButtonColor} variant="contained">
                    {confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
